const LOG_CONST = {

  MANAGER: {

    SEARCH_TYPES: ['MANAGER', 'ACTION_CLASS', 'ACTION', 'MONTH'],
    
    ACTION_CLASSES: [
      'Product',
      'ProductTable',
      'ProductPrice',
      'Plan',
      'PlanProduct',
      'PlanTable',
      'PlanPrice',
      'Subscription',
      'Filter',
      'Notification',
      'Config',
      'Customer',
      'Payment',
      'Sale'
    ],

    ACTIONS: [
      //Product
      'Product',
      'CreateProduct',
      'UpdateProduct',
      'DeleteProduct',

      //ProductTable
      'ProductTable',
      'CreateProductTable',
      'UpdateProductTable',
      'DeleteProductTable',

      //ProductPrice
      'ProductPrice',
      'CreateProductPrice',
      'UpdateProductPrice',
      'DeleteProductPrice',

      //Plan
      'Plan',
      'CreatePlan',
      'UpdatePlan',
      'DeletePlan',

      //PlanProduct
      'PlanProduct',
      'CreatePlanProduct',
      'UpdatePlanProduct',
      'DeletePlanProduct',

      //PlanTable
      'PlanTable',
      'CreatePlanTable',
      'UpdatePlanTable',
      'DeletePlanTable',

      //PlanPrice
      'PlanPrice',
      'CreatePlanPrice',
      'UpdatePlanPrice',
      'DeletePlanPrice',

      //Subscription
      'Subscription',
      'SubscribeCustomer',

      //Filter
      'Filter',
      'CreateFilter',
      'UpdateFilter',
      'DeleteFilter',

      //Notification
      'Notification',
      'CreateNotification',
      'UpdateNotification',
      'DeleteNotification',

      //Config
      'Config',
      'CreateConfigEntry',
      'UpdateConfigEntry',
      'DeleteConfigEntry',

      //Customer
      'Customer',
      'BlockCustomer',
      'UnblockCustomer',
      'CreateCustomer',
      'CreateSponsoredCustomer',
      'UpdateCustomer',
      'DeleteCustomer',

      //Payment
      'Payment',
      'CreatePayment',
      'CreateSubscription',

      //Sale
      'Sale',
      'CreateSale',
      'UpdateSale',
      'DeleteSale'
    ]

  }

}

export default LOG_CONST